<script>
import gql from "graphql-tag";
import { h } from "vue";

const PROBABLY_PHONE =
  /iphone|android|ie|blackberry|fennec/.test(
    navigator.userAgent.toLowerCase(),
  ) && "ontouchstart" in document.documentElement;

export default {
  name: "PhoneNumber",
  props: {
    phone: {
      type: String,
      default: "",
    },
    includeInfo: {
      type: Boolean,
      default: false,
    },
    apollo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      info: null,
    };
  },
  watch: {
    includeInfo: {
      deep: true,

      handler(to) {
        if (to) {
          this.request();
        } else {
          this.info = null;
        }
      },
    },
  },
  mounted() {
    if (this.includeInfo) {
      this.request();
    }
  },
  methods: {
    request() {
      (this.apollo || this.$apollo)
        .mutate({
          mutation: gql`
            mutation ($phone: String!) {
              payload: checkPhone(input: { phone: $phone }) {
                valid
                info
                formatted
                input
              }
            }
          `,
          variables: {
            phone: this.phone,
          },
        })
        .then(({ data: { payload } }) => {
          if (payload) {
            this.info = payload;
          } else {
            this.info = null;
          }
        })
        .catch((e) => {
          this.info = null;
        });
    },
  },
  render() {
    const { info, phone } = this;
    let tag = "span";
    let tagProp = {};

    if (PROBABLY_PHONE) {
      tag = "a";
      tagProp = {
        attrs: {
          href: `tel:${phone}`,
          title: "Telefon",
        },
      };
    }
    return h(
      "span",
      {
        class: "u-no-break",
      },
      [
        h(tag, tagProp, [h("em", { class: "el-icon-phone" })]),
        " ",
        h(tag, tagProp, this.$slots.default()),
        info && info.info ? ` (${info.info})` : "",
      ].filter((e) => !!e),
    );
  },
};
</script>
